import {createStore, withProps} from '@ngneat/elf';
import {entitiesPropsFactory, withEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';
import {JobInvoice, JobInvoiceStatus} from '@store/invoices/jobsInvoice/jobsInvoice.model';
import {Invoice, InvoiceUI} from '@store/invoices/invoices';
import {GridSortItem} from '@mui/x-data-grid-pro';
import {TablePagination} from '@store/common/pagination.model';
import {TableConfig} from '@constants/table.constants';

const {withInvoicesEntities} = entitiesPropsFactory('invoices');
const {withInvoicesUIEntities} = entitiesPropsFactory('invoicesUI');

export interface JobsInvoiceState {
  sort: GridSortItem;
  tablePagination: TablePagination;
  status: JobInvoiceStatus;
  from?: Date;
  to?: Date;
}

export const jobsInvoiceStore = createStore(
  {name: 'jobs-invoice'},
  withProps<JobsInvoiceState>({
    sort: {
      field: 'invoice.status',
      sort: 'asc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
    status: JobInvoiceStatus.TO_BE_VALIDATED,
  }),
  withEntities<JobInvoice>(),
  withInvoicesEntities<Invoice>(),
  withInvoicesUIEntities<InvoiceUI>(),
  withPagination(),
  withRequestsStatus(),
);
